import { useMutation } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { DeleteAddressMutationVariables } from '../fragments.rest';
import { updateAddressesCache } from '../useAddressesQuery/useAddressesQuery.rest';
import { DELETE_ADDRESS_MUTATION, DeleteAddressMutation } from './useDeleteAddressMutation.rest';

export const useDeleteAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation<
    DeleteAddressMutation,
    DeleteAddressMutationVariables
  >(DELETE_ADDRESS_MUTATION);

  const deleteAddress = useCallback(
    async (id: string) => {
      await mutate({
        variables: { id },
        update: (cache, result) => updateAddressesCache(cache, result, id)
      });
    },
    [mutate]
  );

  return [deleteAddress, { loading, error }] as const;
};
